
export default {
    name: "CountdownTimer",
    props: {
        endDate: {
            type: String,
            default: "00/00/00",
        },
        endTime: {
            type: String,
            default: "00:00:00",
        },
        lang: {
            type: String,
            default: "en",
        },
    },
    data() {
        return {
            timerData: {
                date: "00",
                hours: "00",
                minutes: "00",
                seconds: "00",
            },
            timer: null,
        };
    },
    computed: {
        labels() {
            const translations = {
                en: {
                    days: "Days",
                    hours: "Hours",
                    minutes: "Minutes",
                    seconds: "Seconds",
                },
                it: {
                    days: "Giorni",
                    hours: "Ore",
                    minutes: "Minuti",
                    seconds: "Secondi",
                },
                ger: {
                    days: "Tage",
                    hours: "Stunden",
                    minutes: "Minuten",
                    seconds: "Sekunden",
                },
                hu: {
                    days: this.$t(
                        "LANDINGS.ROADSHOW.HEDAER.BANNER.TIMEING.COUNTER.UNITS.DAYS"
                    ),
                    hours: this.$t(
                        "LANDINGS.ROADSHOW.HEDAER.BANNER.TIMEING.COUNTER.UNITS.HOUR"
                    ),
                    minutes: this.$t(
                        "LANDINGS.ROADSHOW.HEDAER.BANNER.TIMEING.COUNTER.UNITS.MINS"
                    ),
                    seconds: this.$t(
                        "LANDINGS.ROADSHOW.HEDAER.BANNER.TIMEING.COUNTER.UNITS.SECONDS"
                    ),
                },
                ar: {
                    days: this.$t(
                        "LANDINGS.ROADSHOW.HEDAER.BANNER.TIMEING.COUNTER.UNITS.DAYS"
                    ),
                    hours: this.$t(
                        "LANDINGS.ROADSHOW.HEDAER.BANNER.TIMEING.COUNTER.UNITS.HOUR"
                    ),
                    minutes: this.$t(
                        "LANDINGS.ROADSHOW.HEDAER.BANNER.TIMEING.COUNTER.UNITS.MINS"
                    ),
                    seconds: this.$t(
                        "LANDINGS.ROADSHOW.HEDAER.BANNER.TIMEING.COUNTER.UNITS.SECONDS"
                    ),
                },
                zh: {
                    days: "天",
                    hours: "小時",
                    minutes: "分鐘",
                    seconds: "秒",
                },
            };
            return translations[this.lang] || translations.en;
        },
    },
    methods: {
        formatTime(value) {
            const formattedValue = String(value).padStart(2, "0");

            if (this.lang === "ar") {
                // Convert English numbers to Arabic
                const arabicDigits = [
                    "٠",
                    "١",
                    "٢",
                    "٣",
                    "٤",
                    "٥",
                    "٦",
                    "٧",
                    "٨",
                    "٩",
                ];
                return formattedValue.replace(
                    /\d/g,
                    (digit) => arabicDigits[digit]
                );
            }

            return formattedValue;
        },
    },
    created() {
        let data = null;
        let dateParams = null;
        let timeParams = null;
        const dateNow = new Date();
        if (this.endDate !== "00/00/00" && this.endTime !== "00:00:00") {
            dateParams = this.endDate.split("/");
            timeParams = this.endTime.split(":");
            data = new Date(
                dateParams[0],
                dateParams[1] - 1,
                dateParams[2],
                timeParams[0],
                timeParams[1],
                timeParams[2]
            );
        } else if (this.endDate !== "00/00/00") {
            dateParams = this.endDate.split("/");
            timeParams = this.endTime.split(":");
            data = new Date(
                dateParams[0],
                dateParams[1] - 1,
                dateParams[2],
                timeParams[0],
                timeParams[1],
                timeParams[2]
            );
        } else if (this.endTime !== "00:00:00") {
            data = new Date(
                dateNow.getFullYear(),
                dateNow.getMonth(),
                dateNow.getDate(),
                timeParams[0],
                timeParams[1],
                timeParams[2]
            );
        }
        if (data.getTime() > dateNow.getTime()) {
            const timerData = Math.abs(data.getTime() - dateNow.getTime());
            const mathDate = {
                date: 1000 * 3600 * 24,
                hours: 1000 * 3600,
                minutes: 1000 * 60,
                seconds: 1000,
            };
            this.timerData.date = Math.floor(timerData / mathDate.date);
            this.timerData.hours = Math.floor(
                (timerData - this.timerData.date * mathDate.date) /
                    mathDate.hours
            );
            this.timerData.minutes = Math.floor(
                (timerData -
                    (this.timerData.date * mathDate.date +
                        this.timerData.hours * mathDate.hours)) /
                    mathDate.minutes
            );
            this.timerData.seconds = Math.floor(
                (timerData -
                    (this.timerData.date * mathDate.date +
                        this.timerData.hours * mathDate.hours +
                        this.timerData.minutes * mathDate.minutes)) /
                    mathDate.seconds
            );
        }
    },
    mounted() {
        this.timer = setInterval(() => {
            if (
                this.timerData.date > 0 &&
                this.timerData.hours === 0 &&
                this.timerData.minutes === 0 &&
                this.timerData.seconds === 0
            ) {
                this.timerData.seconds = 59;
                this.timerData.minutes = 59;
                this.timerData.hours = 23;
                --this.timerData.date;
            } else if (
                this.timerData.hours > 0 &&
                this.timerData.minutes === 0 &&
                this.timerData.seconds === 0
            ) {
                this.timerData.seconds = 59;
                this.timerData.minutes = 59;
                --this.timerData.hours;
            } else if (
                this.timerData.minutes > 0 &&
                this.timerData.seconds === 0
            ) {
                this.timerData.seconds = 59;
                --this.timerData.minutes;
            } else if (this.timerData.seconds > 0) {
                --this.timerData.seconds;
            } else if (this.timerData.seconds === 0) {
                if (this.timerData.minutes > 0) {
                    this.timerData.seconds = 59;
                    --this.timerData.minutes;
                } else {
                    clearInterval(this.timer);
                }
            }
        }, 1000);
    },
    beforeUnmount() {
        clearInterval(this.timer);
    },
};
